import React from 'react';
export function Footer() {
  return <footer className="bg-[#06140d] text-slate-400 py-12 border-t border-[#1a3d2c]" data-id="element-100">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-101">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-102">
          📗 MEGAPACK ENERGÍAS RENOVABLES
        </h4>

        <p className="text-slate-300 mb-6" data-id="element-103">
          Hecho por especialistas, para docentes de energías renovables de toda
          Argentina.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-104">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-slate-200 transition-colors" data-id="element-105">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-106">·</span>
          <span className="hover:text-slate-200 transition-colors" data-id="element-107">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-slate-600 border-t border-[#1a3d2c] pt-8 space-y-3" data-id="element-108">
          <p data-id="element-109">
            © MEGAPACK ENERGÍAS RENOVABLES 2026 — Todos los derechos
            reservados.
          </p>
          <p className="italic text-slate-400/80" data-id="element-110">
            📗🇦🇷 "La próxima clase que des, podés llegar con todo resuelto. El
            material está listo. Solo falta que lo descargues."
          </p>
        </div>
      </div>
    </footer>;
}